import { useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

interface DataTableProps {
  data: any[];
  NoofRecords: number;
  pageNumber: number;
  pageSize: number;
  filterBy: any;
  searchTerm: any;
  onPageChange: any;
}

const AreaDataTable: React.FC<DataTableProps> = (props) => {
  useEffect(() => {
    // Trigger re-render whenever data changes
    
  }, [props.data]);

  return (
    <div className="col-12">
      <div className="card border-noround p-2">
        <DataTable
          value={props.data}
          paginator
          rows={props.pageSize}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          totalRecords={props.NoofRecords}  
          lazy={true}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate={`{first} to {last} of ` + props.NoofRecords}
          first={(props.pageNumber - 1) * props.pageSize}
          onPage={props.onPageChange}
        >
          <Column field="pinCode" header="Pincode" style={{ width: "20%" }} />
          <Column field="areaName" header="Area" style={{ width: "15%" }} />
          <Column field="subDistrictName" header="Sub District" style={{ width: "15%" }} />
          <Column field="districtName" header="District" style={{ width: "18%" }} />
          <Column field="stateName" header="State" style={{ width: "15%" }} />
          <Column field="countryName" header="Country" style={{ width: "15%" }} />
        </DataTable>
      </div>
    </div>
  );
};

export default AreaDataTable;
